import { axiosApi } from './api'

export const video = axiosApi.injectEndpoints({
    endpoints: build => ({
        /*
         * GET streaming url and token of a video by its id
         */
        getStreamingUrl: build.query({
            query: ({ id, isShareeView = false }) =>
                `v1/videos/${id}/_stream?isShareeView=${isShareeView}`,
            transformResponse: res => res.data,
        }),
    }),
    overrideExisting: false,
})

export const { useGetStreamingUrlQuery } = video
